import { useContext, useEffect, useState } from 'react';
import {
  Typography,
  Row,
  Col,
  Card,
  Image,
  Button,
  Space,
  Pagination,
  Badge,
  Rate,
  Divider,
} from 'antd';
import LoadingSkeleton from '../components/LoadingSkeleton';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArticleContext } from '../constants/ArticleContext';
import { formDateString, openURL, removeHiddenArticles } from '../fragments/Helpers';
import { ReadOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBox, faGift } from '@fortawesome/free-solid-svg-icons';

// Global variables for models page
const articlesPerPage = 6;

const ModelsPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { articles } = useContext(ArticleContext);

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    searchParams.get('page') ? parseInt(searchParams.get('page') || '') : 1,
  );

  const visibleArticles = removeHiddenArticles(articles);

  // get the 6 articles for this page
  const startIndex = (currentPage - 1) * articlesPerPage;
  const endIndex = startIndex + articlesPerPage;
  const articlesForPage = visibleArticles.slice(startIndex, endIndex);

  //scroll to top when page changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  return (
    <div>
      <Typography.Title level={3} style={{ textAlign: 'center' }}>
        Scalemates Profile
      </Typography.Title>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
        <Button
          shape='round'
          icon={<FontAwesomeIcon icon={faBox} />}
          onClick={() => openURL('https://www.scalemates.com/profiles/mate.php?id=138770&p=stash')}
        >
          Model Stash
        </Button>
        <Button
          shape='round'
          icon={<FontAwesomeIcon icon={faGift} />}
          onClick={() =>
            openURL('https://www.scalemates.com/profiles/mate.php?id=138770&p=wishlist')
          }
        >
          Wish List
        </Button>
      </div>
      <Divider />
      <Typography.Title>Scale Model Kit Reviews</Typography.Title>
      <Row gutter={16}>
        {articlesForPage.map(model => (
          <Col
            key={model.slug}
            xs={24}
            sm={24}
            md={8}
            lg={8}
            xl={8}
            style={{ paddingBottom: '8px' }}
          >
            <div hidden={loading}>
              <Badge.Ribbon
                color='gold'
                text={model.award ? 'Award Winner' : ''}
                style={{ visibility: model.award ? 'visible' : 'hidden' }}
              >
                <Card
                  hoverable={true}
                  cover={
                    <Image
                      src={model.images[0]}
                      fallback='./images/blank.jpg'
                      preview={false}
                      onClick={() => navigate(`/models/${model.slug}`)}
                      onLoad={() => setLoading(false)}
                    />
                  }
                  actions={[
                    <Button
                      onClick={() => navigate(`/models/${model.slug}`)}
                      icon={<ReadOutlined />}
                    >
                      Read More
                    </Button>,
                  ]}
                >
                  <Card.Meta
                    title={model.title}
                    description={
                      <Space direction='vertical'>
                        <Typography.Text type='secondary'>
                          {formDateString(model.date)}
                        </Typography.Text>
                        <Rate allowHalf disabled value={model.rating} />
                      </Space>
                    }
                  />
                </Card>
              </Badge.Ribbon>
            </div>

            {loading && <LoadingSkeleton />}
          </Col>
        ))}
      </Row>
      <Pagination
        style={{ display: 'flex', justifyContent: 'center' }}
        current={currentPage}
        pageSize={articlesPerPage}
        total={visibleArticles.length}
        onChange={page => {
          setCurrentPage(page);
          setSearchParams({ page: page.toString() });
        }}
      />
    </div>
  );
};

export default ModelsPage;
